<template>
  <div>
    <div class="right-title">
      <span>熟人推荐管理</span>
    </div>
    <div class="content-box">
      <div class="tab-box">
        <el-input placeholder="请输入内容" v-model="num1" type="number">
          <template slot="prepend">熟人推荐模式发布职位冻结金额(元)：</template>
        </el-input>
        <el-input placeholder="请输入内容" v-model="num2" type="number">
          <template slot="prepend">熟人推荐模式查看简历冻结金额(元)：</template>
        </el-input>

        <el-button type="primary" @click="saveData" style="display: block;margin: 20px auto;width: 150px;">保存</el-button>
      </div>
    </div>
    <footerBox class="footer"/>

  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "fabuShen",
    data() {
      return {
        num1:0,
        num2:0
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$emit('setType', 2, 1)
      this.getList()
    },
    methods: {

      // 列表
      getList() {
        this.$api.apiContent.setWebSite({
          adminId: this.user.id
        }).then(res => {
          this.num1= Number(res.data.service_charge)
          this.num2= Number(res.data.resume_fee)
        }).catch(() => {

        })
      },
      saveData(){
        if(!this.num1) return this.$message.error('请输入熟人推荐模式发布职位冻结金额')
        if(!this.num2) return this.$message.error('请输入熟人推荐模式查看简历冻结金额')

        this.$api.apiContent.setWebSite2({
          adminId: this.user.id,
          service_charge:this.num1,
          resume_fee:this.num2,
        }).then(() => {
          this.$message.success('保存成功')
        }).catch((e) => {
          this.$message.error(e.info)
        })

      }

    },
    watch: {

    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .content-box {
    .tab-box{
      width: 600px;
      .el-input{
        margin: 20px 0 0;
      }
    }
  }
</style>

